import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { useJobContext } from 'pages/Job/context';

import { DECLINE_QUOTE_MODAL_ID } from './constants';

export interface DeclineQuoteHook {
  isLoading: boolean;
  onClick: () => void;
}

export default function useDeclineQuote(): DeclineQuoteHook {
  const { isLoading } = useJobContext();
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(
    () => showModal(DECLINE_QUOTE_MODAL_ID),
    [showModal],
  );

  return { isLoading, onClick };
}
